import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function SliderSec() {
  const [sliderImg2Url, setSliderImg2Url] = useState('');

  useEffect(() => {
    // Fetch the image URL from the API
    const fetchSliderImage = async () => {
      try {
        const response = await axios.get('https://kaurinternational.com/backend/admin/api/banner_api.php');
        // Extract the image URL from the first object in the array
        const imageUrl = response.data[0]?.banner_image || ''; // Ensure this matches the API structure
        setSliderImg2Url(imageUrl);
      } catch (error) {
        console.error('Error fetching slider image:', error);
      }
    };

    fetchSliderImage();
  }, []);

  return (
    <section>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="bannerText" data-aos="fade-up">
              <h1 data-aos="fade-up">
                Education in the Way to <span className="primary-text">Success</span>
              </h1>
              <div className="row justify-content-center">
                {/* Counters */}
                <div className="col-md-4 col-4 counter">
                  <div className="green">
                    <div
                      data-aos="fade-up"
                      className="counter-number border-bottom border-primary-1 border-2"
                      data-value="10000"
                      data-append="+"
                    >
                      10000+
                    </div>
                    <div data-aos="fade-up" className="counter-title">
                      Clients
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-4 counter">
                  <div className="yellow">
                    <div
                      data-aos="fade-up"
                      className="counter-number border-bottom border-primary-1 border-2"
                      data-value="95"
                      data-append="%"
                    >
                      95%
                    </div>
                    <div data-aos="fade-up" className="counter-title">
                      Visa Success Rate
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-4 counter">
                  <div className="orange">
                    <div
                      data-aos="fade-up"
                      className="counter-number border-bottom border-primary-1 border-2"
                      data-value="10500"
                      data-append="+"
                    >
                      10500+
                    </div>
                    <div data-aos="fade-up" className="counter-title">
                      Visa Approvals
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="img" data-aos="fade-up">
              {sliderImg2Url ? (
                <img src={sliderImg2Url} alt="Slider" className="img-fluid" />
              ) : (
                <p>Loading image...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
    